import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, View } from 'styles/reactnative'

const TransferableAmount = ({ balance }) => {
	const { t } = useTranslation()
	return (
		<View
			style={{
				flexDirection: 'row',
				width: '100%',
				justifyContent: 'space-between',
			}}>
			<Text size={13}>{t('transferableAmount')}</Text>
			<Text size={13}>{balance} USDT</Text>
		</View>
	)
}

export default TransferableAmount
